import * as React from "react";

function SvgIcChevronRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.293 3.293a1 1 0 011.414 0L17 10.586a2 2 0 010 2.828l-7.293 7.293a1 1 0 01-1.414-1.414L15.586 12 8.293 4.707a1 1 0 010-1.414z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcChevronRight;
